module.exports = __webpack_public_path__ + "img/typescript.ff20dd3e.png";